import { forwardRef } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import { useDispatch } from "react-redux";
import { handleSidebarListingHover } from "@/src/store/hoveredListing";

import FinishedIcon from "assets/svg/finished.svg";

import { LazyImage } from "src/components/common/lazy-image/LazyImage";

import styles from "../styles.module.css";

export const ProjectListMapCard = forwardRef(({ informations, index }, ref) => {
  const { name, images, price, salesStatus, url, id } = informations || {};
  const { priceSummary, priceVisibility } = price || {};
  const isVisiblePrice = priceSummary || false;
  const isSaleFinished = salesStatus === "FINISHED";
  const imageUrl = images?.length > 0 ? images[0] : "/assets/images/not_found_error_image.png";
  const dispatch = useDispatch();
  const isFirstDisplayedListingCard = [0, 1, 2, 3].includes(index);

  const containerClass = classNames(styles.container, styles.projectCardWrapper);

  return (
    <a
      ref={ref}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={containerClass}
      onMouseEnter={() => dispatch(handleSidebarListingHover(id))}
      onMouseLeave={() => dispatch(handleSidebarListingHover(null))}
      id={`listingItem-${id}`}
    >
      <div className={styles.imageWrapper}>
        <LazyImage
          src={imageUrl}
          alt={imageUrl}
          className={styles.image}
          width="80px"
          visibleByDefault={isFirstDisplayedListingCard}
        />
      </div>
      <div className={styles.listingInfoWrapper}>
        <p className={styles.listingInfoTitle}>{name}</p>
        <div className={styles.priceWrapper}>
          {!isSaleFinished && isVisiblePrice && (
            <>
              <span className={styles.listingInfoPrice}>{priceSummary}</span>
              {priceVisibility && (
                <span className={styles.additionalPriceText}>
                  {priceVisibility === "STARTCOUNT" ? "' den başlayan" : null}
                </span>
              )}
            </>
          )}
          {!isSaleFinished && ["HIDDEN", "ASK"].includes(priceVisibility) && (
            <p className={styles.learnPrice}>Fiyat Sor</p>
          )}
          {isSaleFinished && (
            <div className={styles.finishedSale}>
              <FinishedIcon />
              <span className={styles.finishedTitle}>Satışı Tamamlandı</span>
            </div>
          )}
        </div>
      </div>
    </a>
  );
});

ProjectListMapCard.propTypes = {
  informations: PropTypes.object,
  index: PropTypes.number,
};

ProjectListMapCard.displayName = "ProjectListMapCard";
